import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  notClearedSurgeries: {
    data: [],
    isLoading: false,
    message: null,
  },
};

export const patientSurgerySlice = createSlice({
  name: "patientSurgeries",
  initialState,
  reducers: {
    loadingNotClearedSurgeries: (state) => {
      state.notClearedSurgeries.isLoading = true;
      state.notClearedSurgeries.message = null;
    },
    loadedNotClearedSurgeries: (state, { payload }) => {
      state.notClearedSurgeries.data = payload.patientSurgeries;
      state.notClearedSurgeries.isLoading = false;
      state.notClearedSurgeries.message = {
        type: "success",
        text: payload.message,
      };
    },
    failedNotClearedSurgeries: (state, { payload }) => {
      state.notClearedSurgeries.isLoading = false;
      state.notClearedSurgeries.message = {
        type: "error",
        text: payload,
      };
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  loadingNotClearedSurgeries,
  loadedNotClearedSurgeries,
  failedNotClearedSurgeries,
} = patientSurgerySlice.actions;
